import { render, staticRenderFns } from "./CanalInstagramSinglePage.vue?vue&type=template&id=4caa1802&scoped=true&lang=pug"
import script from "./CanalInstagramSinglePage.vue?vue&type=script&lang=js"
export * from "./CanalInstagramSinglePage.vue?vue&type=script&lang=js"
import style0 from "./CanalInstagramSinglePage.vue?vue&type=style&index=0&id=4caa1802&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4caa1802",
  null
  
)

export default component.exports